<template>
  
  <div class="mt-12 pb-20">
        
        <label class="border-2 rounded bg-blue-600 p-1 mt-2 mb-4"> {{$t('business.brokerDetails')}}</label>

        <div  v-for="(business,index) in brokerBusiness" :key="index" class="mt-2 mb-2">

          <div @click="displayTransferRequests(business.user_business_points[0].transfer_requests)" class="border border-blue-800 rounded">
          
            <div class="flex w-full justify-around mt-2 mb-2">

              <div class="w-24">

                  <label class="text-black"> {{$t('business.business')}}</label>
              </div>

              <div class="w-60 flex justify-center">

                <label class="rounded bg-blue-200 text-black"> {{business.name}}</label>
              </div>
            </div>

            <div class="flex w-full justify-around mt-2 mb-2">

              <div class="w-24">

                  <label class="text-red-600"> {{$t('classes.points')}}</label>
              </div>

              <div class="w-60 flex justify-center ">

                <label class="rounded bg-blue-200 text-black"> {{business.user_business_points[0].points}}</label>
              </div>
            </div>

             <div class="flex w-full justify-around mt-2 mb-2">

              <div class="w-24">

                  <label class="text-red-600"> {{$t('classes.cash')}}</label>
              </div>

              <div class="w-60 flex justify-center ">

                <label class="rounded bg-blue-200 text-black"> {{business.user_business_points[0].cash}}</label>
              </div>
            </div>

            <div class="flex w-full justify-around mt-2 mb-2">

              <div class="w-24">

                  <label class="text-red-600"> {{$t('business.totalPoints')}}</label>
              </div>

              <div class="w-60 flex justify-center">

                <label class="rounded bg-blue-200 text-black"> {{business.user_business_points[0].total_points}}</label>
              </div>
            </div>

            <div class="flex w-full justify-around mt-2 mb-2">

              <div class="w-24">

                  <label class="text-red-600"> {{$t('business.totalCash')}}</label>
              </div>

              <div class="w-60 flex justify-center ">

                <label class="rounded bg-blue-200 text-black"> {{business.user_business_points[0].total_cash}}</label>
              </div>
            </div>
      
          </div>
        </div>

        <!-- <div v-if="showBusinessDetails"> -->

        <transition  name="bottom-up">

          <div v-if="showTransferRequests && transferRequestsDetails != null"
          class="modalDiv myFullCenter h-full">
              

              <div class="subModalDiv" v-click-outside="closePage">

                  <transfer-requests-page :transferRequestsDetails="transferRequestsDetails" :closePage="closePage"/>
              </div>
          </div>
        </transition>

  </div>
</template>

<script>

import moment from 'moment';

import componentsHelpers from '../classes/componentHelpers';

import myQueries from '../hasura/myQueries';

import TransferRequestsPage from '../components-v2/MyPages/TransferRequestsPage.vue'

export default {

    mounted(){

      // console.log(`userId: ${JSON.stringify(this.$userId)}`)
    },

    components:{

      TransferRequestsPage,
    },

    methods:{

      closePage(){

        this.showTransferRequests = false;

        this.transferRequestsDetails = null;
      },

      displayTransferRequests(business){
      
        this.showTransferRequests = true;

        this.transferRequestsDetails = business;
      },
    },

    apollo:{

        brokerBusiness: {
            
        query: myQueries.broker_business,
          
          variables() {
          
            return {
            
            brokerId: this.$userId
          }
        },

        update(data){

          // console.log(`broker_business: are ${JSON.stringify(data)}`);

          this.ownerBusiness = data.business;

          // this.businessOptions = data.business;

          return data.business;
        },
      
        error(error){
          
          if(this.brokerBusinessError != '' ){

            componentsHelpers.sendError(this.$apollo, this.userId,'BrokerReport', 'apollo', 'brokerBussiness', error);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
          }

          this.brokerBusinessError = JSON.stringify(error);
        },
        skip(){

            // console.log(`this.$userId: ${this.$userId}`)
          return JSON.stringify(this.$userId) == '{}';
        }
      },
    },

    data:  function(){

        return{

            brokerBusiness: [],

            brokerBusinessError: '',

            showTransferRequests: false,

            transferRequestsDetails: null,
          
        }
    }
}
</script>

<style>

.bottom-up-enter-active{

animation: slide-bottom-up 0.5s ease-in;
}

.bottom-up-leave-active{

animation: slide-top-down 0.5s ease-in;
}

@keyframes slide-bottom-up{
    from  { transform: translateY(100%);}
    to { transform: translateY(0);} 
}
@keyframes slide-top-down{
from  { transform: translateY(0%);}
to { transform: translateY(100%);} 
}

.right-in-enter-active{

animation: slide-right-in 0.5s ease-in;
}

.right-in-leave-active{

animation: slide-right-out 0.5s ease-in;
}

@keyframes slide-right-in{
    from  { transform: translateX(100%);}
    to { transform: translateX(0);} 
}
@keyframes slide-right-out{
from  { transform: translateX(0%);}
to { transform: translateX(100%);} 
}



</style>